import apiGlobales from "@/components/services/apiGlobales";

export const globalesMixin = {
  methods: {
    // metodo que se ejecuta al validar un campo del formulario
    validarCampo(ruta, campo, valor, contenedor) {

      // obtener valor del evento segun el tipo de campo que envia el dato
      if(valor.target != undefined) {
        valor = valor.target.value;
      }
      

      // si el valor es undefined, se cancela la validación
      if (typeof valor == "undefined") {
        return false;
      }

      this.$Progress.start();

      // verificar si el campo es numerico y no es fecha (las fechas son reconocidas como numeros)
      if (!(valor instanceof Date)) {
        if (
          !isNaN(this.$numeral(valor)._value) &&
          this.$numeral(valor)._value != null
        ) {
          valor = this.$numeral(valor)._value;
        }
      }

      // obtener todos los campos del contenedor que deben ser validados y enviado a la funcion de validación
      var valoresAdicionales = {};
      for (var key in this[contenedor + "Estado"]) {
        if (this[contenedor + "Estado"][key].valida) {
          // si el valor que se esta evaluando es el campo validado, se obtiene el valor actual (en caso de ser select tomaba el valor anterior)
          if (key == campo) {
            valoresAdicionales[key] = valor;
          }
          // de lo contrario obtiene el valor del contenedor
          else {
            valoresAdicionales[key] = this[contenedor][key];
          }
          // cambiar contenidos undefined por null
          if (typeof valoresAdicionales[key] == "undefined") {
            valoresAdicionales[key] = null;
          }
        }
      }

      // mapear el campo al de valicacion y transformar valores adicionales a texto
      var campoReal = "val_" + campo;
      valoresAdicionales = JSON.stringify(valoresAdicionales);

      // realizar la validacion del campo en la base de datos
      return apiGlobales
        .validarCampo(this.$session.get("mail"), ruta, campoReal, valor, valoresAdicionales)
        .then(response => {
          // recorrer todos los campos devueltos por la validación
          response.data = this.keysMinuscula(response.data);
          var respuesta = response.data.festado;
          for (var key in respuesta) {
            // no considerar el valor de "resultado"
            if (key != "resultado") {

              // si el item no existe en el estado del contenedor, se debe crear como objeto, de lo contrario no hay reactividad
              if (!(key in this[contenedor + "Estado"])) {
                this.$set(
                  this[contenedor + "Estado"],
                  key,
                  {}
                );
              }

              // si el contenido del campo viene vacio, quitar mensaje
              if (Object.keys(respuesta[key]).length == 0) {
                this.mensajeValidacionCampo[key] = "";
                delete this.mensajeValidacionCampo[key];
              }

              // bloquear campo
              if ("bloqueo" in respuesta[key]) {
                // almacenar el valor antiguo del campo que se bloquea
                if (respuesta[key].bloqueo) {
                  this[contenedor + "Antiguo"][key] = this[contenedor][key];
                }
                // si se desbloquea, recuperar el valor antiguo
                else {
                  this[contenedor][key] = this[contenedor + "Antiguo"][key];
                }
              }

              // cambiar mensaje de error
              if ("mensaje" in respuesta[key]) {
                // eliminar el mensaje
                this.mensajeValidacionCampo[key] = "";
                delete this.mensajeValidacionCampo[key];
                // si viene un nuevo mensaje, asignarlo
                if (respuesta[key].mensaje != null) {
                  this.$set(
                    this.mensajeValidacionCampo,
                    key,
                    respuesta[key].mensaje.descripcion
                  );
                }
              }

              // cambiar valor del campo
              if ("valor" in respuesta[key]) {
                // si el key no existe en el contenedor, se crea con null, de lo contrario no hay reactividad
                if (!(key in this[contenedor])) {
                  this.$set(
                    this[contenedor],
                    key,
                    null
                  );
                }
                // asignar el nuevo valor
                this[contenedor][key] = respuesta[key].valor;
                this.$set(
                  this[contenedor],
                  key,
                  respuesta[key].valor
                );
              }

              // actualizar estado, de modo tal que si no viene una propiedad, no se sobreescribe (se mantiene lo anterior)
              for (var clave in respuesta[key]) {
                this[contenedor + "Estado"][key][clave] = respuesta[key][clave];
              }

            }
          }

          this.$Progress.finish();
        })
        .catch(error => console.log(error));
    },


    // metodo que crea un error
    crearError(respuesta, contenedor) {
      var erroresToastr = {};
      // buscar errores de campos de respuesta
      for (var key in respuesta) {
        if (key != 'resultado') {
          if (respuesta[key].mensaje != null) {
            // si se encuentra un error
            if (respuesta[key].mensaje.descripcion != null) {
              // si el campo no existe en el formulario, se agrega para mostrar en caja de error toastr
              if (!(key in this[contenedor])) {
                erroresToastr[key] = respuesta[key];
              }
            }
          }
        }
      }

      // agregar al listado el error que viene en resultado
      var respuestaError = respuesta.resultado.mensaje;

      // generar listado de errores con aquellos campos que no existen en el formulario
      respuestaError = respuestaError + this.crearListaDeErrores(erroresToastr);

      // mostrar errores en formulario
      if (respuesta.resultado.estado == "error") {
        this.mostrarErroresEnFormulario(respuesta);
      }

      return respuestaError;
    },

    cargaErrores(mensajes)
    {
        let _this = this;
        var mensajeError = "<ul>";
        let v_temp =Object.entries(mensajes);

        v_temp.forEach(
                        function(item)
                        {
                            let listaDeObjectos = Object.keys(item[1]).map((key) => {
                                if (key!='resultado')
                                    if(item[1][key]!==undefined)
                                        if (item[1][key].mensaje!==undefined)
                                            return item[1][key];
                            });

                            let v_temp2 =Object.entries(listaDeObjectos);
                            v_temp2.forEach(
                                            function(item2)
                                            {
                                                if (item2!==undefined)
                                                    if (item2[1]!=undefined)
                                                        mensajeError = mensajeError + "<li>" + item2[1].mensaje.descripcion + "</li>";
                                            });

                        });
        mensajeError = mensajeError + "</ul>";
        return mensajeError;
    },

    // metodo crea un listado de errores
    crearListaDeErrores(errores) {
      var mensajeError = '';
      if (Object.keys(errores).length > 0) {
        var mensajeError = "<ul>";
        for (var key in errores) {
          if (errores[key].mensaje != null) {
            if (errores[key].mensaje.descripcion != null) {
              mensajeError = mensajeError + "<li>" + errores[key].mensaje.descripcion + "</li>";
            }
          }
        }
        mensajeError = mensajeError + "</ul>";
      }
      return mensajeError;
    },

    // metodo muestra todos los errores en el formulario
    mostrarErroresEnFormulario(errores) {
      // primero eliminar todos los errores del formulario
      this.mensajeValidacionCampo = {};
      for (var key in errores) {
        if (errores[key].mensaje != null) {
          this.$set(
            this.mensajeValidacionCampo,
            key,
            errores[key].mensaje.descripcion
          );
        }
      }
    },

    // metodo que crea un label y define si es obligatorio o no
    crearLabel(texto, id, contenedor) {
      if (!id || !contenedor || id == "" || contenedor == "") {
        return texto;
      } else {
        if (!(typeof this[contenedor + "Estado"] == "undefined")) {
          if (id in this[contenedor + "Estado"]) {
            if (this[contenedor + "Estado"][id].obliga) {
              return texto + ' *';
            } else {
              return texto;
            }
          } else {
            return texto;
          }
        }
      }
    },

    // metodo que devuelve un campo esta bloqueado o no
    campoBloqueado(id, contenedor) {
      if (!(typeof this[contenedor + "Estado"] == "undefined")) {
        // detectar si existe bloqueo global en el formulario, de ser asi, bloquear todo el formulario
        if (!(typeof this[contenedor + "Estado"]['bloqueo_global'] == "undefined")) {
          if (this[contenedor + "Estado"]['bloqueo_global']) {
            return true;
          }
        }
        // detectar si el campo esta bloqueado o no
        if (id in this[contenedor + "Estado"]) {
          if (this[contenedor + "Estado"][id].bloqueo) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },


    // metodo que compara los valores seleccionados de dos objetos
    compararCamposEditables(objeto1, objeto2, valoresExcluidos) {
      var esDiferente = false;
      for (var key in objeto1) {
        if (!valoresExcluidos.includes(key)) {
          var contenido1 = objeto1[key];
          var contenido2 = objeto2[key];
          // verificar si el campo es numerico
          if (
            !isNaN(this.$numeral(contenido1)._value) &&
            this.$numeral(contenido1)._value != null
          ) {
            contenido1 = this.$numeral(contenido1)._value;
          }
          if (
            !isNaN(this.$numeral(contenido2)._value) &&
            this.$numeral(contenido2)._value != null
          ) {
            contenido2 = this.$numeral(contenido2)._value;
          }
          if (contenido1 != contenido2) {
            esDiferente = true;
          }
          if (contenido1 == "" && contenido2 == null) {
            esDiferente = false;
          }
          if (contenido1 == null && contenido2 == "") {
            esDiferente = false;
          }
          if (contenido1 == "" && contenido2 == "<p></p>") {
            esDiferente = false;
          }
          if (contenido1 == "<p></p>" && contenido2 == "") {
            esDiferente = false;
          }
          if (esDiferente) {
            return false;
          }
        }
      }
      if (esDiferente) {
        return false;
      } else {
        return true;
      }
    },


    // metodo que crea una notificacion
    crearNotificacion(titulo, mensaje, tipo) {
      this.mensajeToastr({
        title: titulo,
        message: mensaje,
        type: tipo,
        timeout: 6000
      });
      if (tipo == 'error') {
        console.log(mensaje);
        this.$Progress.fail();
      }
    },

    // metodo que crea una notificacion con mayor tiempo de espera
    crearNotificacion1(titulo, mensaje, tipo) {
      this.mensajeToastr({
        title: titulo,
        message: mensaje,
        type: tipo,
        timeout: 8000
      });
      if (tipo == 'error') {
        console.log(mensaje);
        this.$Progress.fail();
      }
    },


    // metodo convierte a minusulas todos los keys de un objeto
    keysMinuscula(item) {
      if (Array.isArray(item)) {
        var output = [];
      }
      else {
        var output = {};
      }

      for (var i in item) {
        if (Object.prototype.toString.apply(item[i]) === '[object Object]') {
          output[i.toLowerCase()] = this.keysMinuscula(item[i]);
        } else if (Object.prototype.toString.apply(item[i]) === '[object Array]') {
          output[i.toLowerCase()] = [];
          var that = this;
          item[i].forEach(function (entry) {
            output[i.toLowerCase()].push(that.keysMinuscula(entry));
          });
        } else {
          output[i.toLowerCase()] = item[i];
        }
      }
      return output;
    },
  },
  computed: {
    // mostrar o esconder boton guardar
    botonGuardar: function () {
      if (!(typeof this.datosFormularioEstado == "undefined")) {
        if (!(typeof this.datosFormularioEstado.botones == "undefined")) {
          if (this.datosFormularioEstado.botones.guardar) {
            return true;
          }
        }
      }
    },
    // mostrar o esconder boton aprobar
    botonAprobar: function () {
      if (!(typeof this.datosFormularioEstado == "undefined")) {
        if (!(typeof this.datosFormularioEstado.botones == "undefined")) {
          if (this.datosFormularioEstado.botones.aprobar) {
            return true;
          }
        }
      }
    },
    // mostrar o esconder boton rechazar
    botonRechazar: function () {
      if (!(typeof this.datosFormularioEstado == "undefined")) {
        if (!(typeof this.datosFormularioEstado.botones == "undefined")) {
          if (this.datosFormularioEstado.botones.rechazar) {
            return true;
          }
        }
      }
    },
    // mostrar o esconder boton desistir
    botonDesistir: function () {
      if (!(typeof this.datosFormularioEstado == "undefined")) {
        if (!(typeof this.datosFormularioEstado.botones == "undefined")) {
          if (this.datosFormularioEstado.botones.desistir) {
            return true;
          }
        }
      }
    },
    // mostrar o esconder boton versionar
    botonVersionar: function () {
      if (!(typeof this.datosFormularioEstado == "undefined")) {
        if (!(typeof this.datosFormularioEstado.botones == "undefined")) {
          if (this.datosFormularioEstado.botones.versionar) {
            return true;
          }
        }
      }
    },
    // mostrar o esconder boton eliminar
    botonEliminar: function () {
      if (!(typeof this.datosFormularioEstado == "undefined")) {
        if (!(typeof this.datosFormularioEstado.botones == "undefined")) {
          if (this.datosFormularioEstado.botones.eliminar) {
            return true;
          }
        }
      }
    },
    // mostrar o esconder boton emitir
    botonEmitir: function () {
      if (!(typeof this.datosFormularioEstado == "undefined")) {
        if (!(typeof this.datosFormularioEstado.botones == "undefined")) {
          if (this.datosFormularioEstado.botones.emitir) {
            return true;
          }
        }
      }
    },
    // mostrar o esconder boton reiniciar
    botonReiniciar: function () {
      if (!(typeof this.datosFormularioEstado == "undefined")) {
        if (!(typeof this.datosFormularioEstado.botones == "undefined")) {
          if (this.datosFormularioEstado.botones.reiniciar) {
            return true;
          }
        }
      }
    }
  },
  // inicialización de los mensajes de error
  notifications: {
    mensajeToastr: {
      title: "",
      message: "",
      type: ""
    }
  }
};
